import { connect } from 'react-redux'

import UpgradePath from './components/UpgradePath'
import type { RootState } from '../store/index'

export default connect((state: RootState) => ({
  shouldShowUpgradeButton:
    state.organizations.selected?.shouldShowUpgradeButton,
}))(UpgradePath)
